module.exports = __webpack_public_path__ + "static/assets/4228211bf21ef065de9c5ad5e19c3cd3.svg";